import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import LoginForm from "../components/LoginForm";
import logo from "../assets/logo_treso.png";
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useGlobalAlert } from "../contexts/alertContext";
import { UserContext } from "../contexts/userContext";
import { LoadingButton } from "@mui/lab";

const Login = () => {
  const { userData, handleSetUser } = useContext(UserContext);
  const [loginInfo, setloginInfo] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { showAlert } = useGlobalAlert();
  const navigate = useNavigate();

  const handleChange = (type: string, value: string) =>
    setloginInfo({ ...loginInfo, [type]: value });

  const validateEmail = (email: string) => {
    // Simple regex for email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validatePassword = (password: string) => {
    // At least 8 chars, one uppercase, one lowercase, one number
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password);
  };

  const handleSubmit = async () => {
    setError("");
    if (!validateEmail(loginInfo.email)) {
      setError("Ingrese un correo electrónico válido.");
      return;
    }
    if (!validatePassword(loginInfo.password)) {
      setError(
        "La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número."
      );
      return;
    }
    const auth = getAuth();
    setLoading(true);
    await signInWithEmailAndPassword(auth, loginInfo.email, loginInfo.password)
      .then(async (userCredential) => {
        handleSetUser(userCredential.user.uid);
      })
      .catch((error) => {
        showAlert("Error de autenticación: " + (error?.message || ""), "error");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      navigate(userData.role === "KITCHEN" ? "/orders" : "/");
    }
  }, [userData]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      width="100vw"
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="fit-content"
        width="fit-content"
        p={2}
        sx={{
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          borderRadius: "10px",
          backgroundColor: "#FFFFFF",
        }}
      >
        <img src={logo} alt="Logo" className="login_logo" />
        <Typography>Treso</Typography>
        <LoginForm
          loginInfo={loginInfo}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
        {error && (
          <Typography color="error" fontSize={14} mb={2}>
            {error}
          </Typography>
        )}
        <LoadingButton
          loading={loading}
          disabled={loading}
          variant="contained"
          onClick={handleSubmit}
        >
          Iniciar sesion
        </LoadingButton>

        <Button
          color="secondary"
          variant="text"
          onClick={() => navigate("/signup")}
        >
          Crear cuenta
        </Button>
      </Box>
    </Box>
  );
};

export default Login;
